import Fetcher from "../fetcher";
import { isPlainObject, getValueAtPath, withProperties } from "../utils";
import { falseFunction } from "./helpers";
import {
  DEFAULT_RETRY_CONDITIONS,
  isJsonResponse,
  withSharedHeaders
} from "../fetcher/utils";
import { type } from "../charge/utils";

let SA_BANKS_LIST = withProperties(Object.create(null), null);

const $fetcher = withSharedHeaders(Fetcher.one
  .limit(5)
  .timeout(6000)
  .retry(DEFAULT_RETRY_CONDITIONS));

function fetchSouthAfricanBanks(context) {
  return Promise.resolve(
    Object.isFrozen(SA_BANKS_LIST) || 
      $fetcher(new URL(`/flwv3-pug/getpaidx/api/sa_banks?PBFPubKey=${getValueAtPath(context, 'DATA.PBFPubKey')}`, process.env.API_BASE_URL))
        .then(response => {
          if (isJsonResponse(response)) {
            return response.json()
              .then(response => {
                let fetched = false;
                const { data } = isPlainObject(response) ? response : {};

                if (type(data) === 'array') {
                  try {
                    withProperties(SA_BANKS_LIST, {
                      banks: data
                    });

                    fetched !== true && (fetched = true);
                  } catch (e) {}
                }

                return !!(fetched === true && Object.freeze(SA_BANKS_LIST));
              })
          }
    })
    .catch(falseFunction)
  );
}

function selectSouthAfricanBank(list, bank) {
  if (type(list) !== 'array') return null;

  if (list.indexOf(bank) < 0) {
    const { name: bankName, code: bankCode } = isPlainObject(bank) ? bank : (
      /^\d{2,}$/.test(bank)
        ? { code: bank }
        : { name: String(bank) }
    );

    bank = list.find(item => {
      if (isPlainObject(item)) {
        const { name, code } = item;

        const hasName = typeof bankName !== 'undefined';
        const hasCode = typeof bankCode !== 'undefined';

        let matches = (hasName || hasCode) ? 1 : 0;

        hasName && (matches = matches & (bankName === name));
        hasCode && (matches = matches & (bankCode === code));

        return matches;
      }
    });
  }

  return bank || null;
}

export {
  SA_BANKS_LIST,
  fetchSouthAfricanBanks,
  selectSouthAfricanBank
}